import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SystemGeneratorPage from "./SystemGeneratorPage";
import "./RecruitmentBuilderPage.css";
import LogoImg from "../assets/layerbound-white.png";

function RecruitmentBuilderPage({ business = null }) {
  const [useApprenticeshipEnquiryFlow, setUseApprenticeshipEnquiryFlow] = useState(true);

  return (
    <div className="recruitment-builder">
      <section className="recruitment-builder__intro">
        <div className="recruitment-builder__nav">
          <Link to="/" className="recruitment-builder__back">
            <ArrowLeft size={16} />
            Back to home
          </Link>
        </div>
        <div className="recruitment-builder__brand">
          <img src={LogoImg} alt="Layerbound" />
          <span>Layerbound</span>
        </div>
        <h2>Apprenticeship Intake Link</h2>
        <p className="recruitment-builder__description">
          For training providers and colleges running apprenticeship enquiries. We’ll generate a
          branded employer enquiry link in minutes.
        </p>
        <p className="recruitment-builder__hint">
          Keep it short: intent, company, contact preference, start timeframe, and any follow-up
          detail you need.
        </p>
        <label className="recruitment-builder__flow-toggle">
          <input
            type="checkbox"
            checked={useApprenticeshipEnquiryFlow}
            onChange={(e) => setUseApprenticeshipEnquiryFlow(e.target.checked)}
          />
          <span>Use apprenticeship enquiry flow</span>
        </label>
      </section>
      <div className="recruitment-builder__content">
        <SystemGeneratorPage
          business={business}
          systemTypeOverride="recruitment"
          intakeDefault
          apprenticeshipEnquiryFlowOverride={useApprenticeshipEnquiryFlow}
          hideAdvancedOptions
        />
      </div>
    </div>
  );
}

export default RecruitmentBuilderPage;
